import { LoginViewState } from "../types";
import { Mail } from "lucide-react";
import { StatusIconCircle } from "@/components/common/StatusIconCircle";
import { SubmitButton } from "../components/SubmitButton";
import { ViewHeading } from "../components/ViewHeading";

type Props = {
  onViewChange: (view: LoginViewState) => void;
};

export const ForgotPasswordSentView = ({ onViewChange }: Props) => (
  <>
    <StatusIconCircle variant="brand" icon={Mail} />

    <ViewHeading
      title="Check your email"
      subtitle="A password reset link has been sent. If your account and email address are registered, you
      will receive an email shortly. If you do not receive an email please contact your local Klipboard CRM
      administrator."
    />

    <SubmitButton type="button" onClick={() => onViewChange("login")}>
      Back to login
    </SubmitButton>
  </>
);
